<template>
  <el-upload
    v-loading="loading"
    class="image-upload"
    drag
    :action="url"
    :show-file-list="false"
    :on-success="onSuccess"
    :before-upload="onBeforeUpload">
    <img v-if="imageUrl" :src="imageUrl" class="image-preview">
    <div v-else>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </div>
  </el-upload>
</template>

<style lang="scss">
.image-upload {
  display: inline-block;
}
.image-preview {
  display: inline-block;
  max-height: 100%;
  max-width: 100%;
}
</style>

<script>
import config from '@/config'

export default {
  props: {
    value: {
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      url: config.uploader.image.url,
      imageUrl: this.value
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.loading = false
      this.$emit('input', this.imageUrl)
    },
    onBeforeUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      let result = isJPG && isLt2M
      if (result) {
        this.loading = true
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ImageUpload.vue